import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import EmptyDataImg from './../../assets/images/empty-data.png';

const EmptyData: FC<{ message: string }> = ({ message }) => {
	return (
		<Stack margin={2} alignItems='center' alignContent='center'>
			<Typography sx={{ color: 'text.secondary', mb: 5 }} variant='h5'>
				Sorry, {message}
			</Typography>
			<img src={EmptyDataImg} alt='Empty data' width={400} />
		</Stack>
	);
};

export default EmptyData;
